<div class="wrapper">
    <div class="abs-center wd-xl">
        <!-- START card-->
        <div class="text-center mb-4">
            <div class="text-lg mb-3">
                <em class="fa fa-wrench fa-2x text-muted"></em>
            </div>
            <div class="text-lg mb-3">{{ 'ROUTES.PAGES.500.TITLE' | translate }}</div>
            <p class="lead m-0">{{ 'ROUTES.PAGES.500.SUBTITLE' | translate }}</p>
            <p>{{ 'ROUTES.PAGES.500.DESCRIPTION' | translate }}</p>
        </div>
        <ul class="list-inline text-center mb-4">
            <li class="list-inline-item">
                <a class="text-muted" [routerLink]="'/events'">{{ 'ROUTES.PAGES.500.LINK.BACK' | translate }}</a>
            </li>
            <li class="text-muted list-inline-item">{{ 'PIPE' | translate }}</li>
            <li class="list-inline-item">
                <a class="text-muted" [routerLink]="'/'">{{ 'ROUTES.PAGES.500.LINK.LOGIN' | translate }}</a>
            </li>
        </ul>
    </div>
</div>
